<template>
  <form-panel
    v-loading.fullscreen.lock="fullscreenLoading"
    width="medium"
    @closePanel="onClose">
    <preview-campaign
      :image="itemCampaign.img"
      :title="itemCampaign.name"
      :content="itemCampaign.content"/>
    <el-row
      type="flex"
      justify="center">
      <el-col :span="6">
        <el-button
          :disabled="active"
          icon="el-icon-tickets"
          @click="showModalComments = true">
          Ver comentarios</el-button>
      </el-col>
    </el-row>
    <form-modal
      v-if="showModalComments"
      @closeModal="closeModalComment">
      <div class="comments">
        <h4>Comentarios</h4>
        <p
          v-for="(item, index) in comments"
          :key="index">{{ item.description }}</p>
      </div>
    </form-modal>
  </form-panel>
</template>

<script>
import FormPanel from '@/components/_shared/form-panel'
import FormModal from '@/components/_shared/form-modal'
import PreviewCampaign from '@/modules/campaigns/_shared/preview-campaign'
export default {
  name: 'CampaignPreviewEmailPanel',
  components: {
    FormPanel,
    FormModal,
    PreviewCampaign
  },
  props: {
    itemCampaign: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      showModalComments: false,
      campaign: this.itemCampaign,
      comments: [],
      contentCampaign: [],
      fullscreenLoading: false,
      active: true
    }
  },
  mounted () {
    this.fullscreenLoading = true
    Promise.all([
      this.$store.dispatch('campaignComments/query', {'filters[where][campaignId][eq]': this.itemCampaign.id}),
      this.$store.dispatch('campaignContents/query', {'filters[where][campaignId][eq]': this.itemCampaign.id})
    ]).then((data) => {
      this.comments = data[0].data.items
      this.contentCampaign = data[1].data.items
      this.active = !(this.comments.length > 0)
      for (let i = 0; i < this.contentCampaign.length; i++) {
        if (this.itemCampaign.id === parseInt(this.contentCampaign[i].campaignId)) {
          this.itemCampaign.img = `${process.env.API_URL_IMAGES}${this.contentCampaign[i].banner}`
          this.itemCampaign.content = this.contentCampaign[i].content
        }
      }
    }).catch(e => {
      this.$notify.error({
        message: 'Por favor, vuelve a intentarlo.'
      })
    }).finally(() => {
      this.fullscreenLoading = false
    })
  },
  methods: {
    onClose () {
      this.$store.dispatch('app/toogglePreviewMail')
    },
    closeModalComment () {
      this.showModalComments = false
    }
  }
}
</script>

<style scoped lang="scss">
  .comments {
    padding: 20px;
    position: relative;
    width: 400px;
    max-height: 600px;
    overflow: auto;
    h4 {
      @include font-primary(18px, regular);
      margin: 0 0 25px 0;
    }
    p {
      @include font-primary(14px, regular);
      border-bottom: 2px solid #F1F1F1;
      padding: 6px 0 6px 10px;
      margin: 0 0 10px 0;
      &:last-child {
        margin: 0;
        border-bottom: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/modules/campaigns/campaign-preview-email-panel.vue